import React from 'react';
import GitInfo from 'react-git-info/macro';

import packageJson from '../../../package.json';

import s from './Version.module.scss'

const gitInfo = GitInfo();

const isStaging = () => {
  return process.env.REACT_APP_API_ENDPOINT?.includes('stagingapi') ||
         window.location.hostname.includes('staging');
};

const isLocalhost = () => {
  return window.location.hostname === 'localhost';
};

const shouldShowBranch = () => {
  return isStaging() || isLocalhost();
};

export const Version: React.FC = () => {
  const branchName = gitInfo?.branch;
  const showBranch = shouldShowBranch() && branchName;

  return (
    <small className={s.version}>
      v{packageJson.version}
      {showBranch && ` (${branchName})`}
    </small>
  );
};
